import { render, staticRenderFns } from "./VideoProduct.vue?vue&type=template&id=1b5d6bef&scoped=true&"
import script from "./VideoProduct.vue?vue&type=script&lang=js&"
export * from "./VideoProduct.vue?vue&type=script&lang=js&"
import style0 from "./VideoProduct.vue?vue&type=style&index=0&id=1b5d6bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d6bef",
  null
  
)

export default component.exports